/** As 8 etapas do pedido no painel do fluxo (texto do design aprovado). */
export const ETAPAS = [
  { nome: "Comercial", descricao: "Orçamento aprovado e contrato fechado com o cliente." },
  { nome: "Projetos", descricao: "Projeto executivo detalhado e liberado para a fábrica." },
  { nome: "Compras", descricao: "Chapas, ferragens e serviços de terceiros solicitados." },
  { nome: "Corte", descricao: "Plano de corte otimizado no PharuCut e enviado à serra." },
  { nome: "Marcenaria", descricao: "Usinagem, furação e pré-montagem dos módulos." },
  { nome: "Acabamento", descricao: "Revisão de qualidade e acabamento final das peças." },
  { nome: "Expedição", descricao: "Volumes conferidos, etiquetados e carregados." },
  { nome: "Montagem", descricao: "Instalação na obra e assistência quando precisar." },
];

export const ETAPA_INICIAL = 3;

/** Ciclo do design: a cada 3,2 s a linha anda para a próxima etapa. */
export const CICLO_MS = 3200;
/** O texto da etapa atual começa a sair 0,5 s depois de a linha partir. */
export const SAIDA_DO_TEXTO_MS = 500;
/** Rede de segurança: se o transitionend não vier (reduced-motion), chega mesmo assim. */
export const CHEGADA_FORCADA_MS = 1300;

export function numeroDaEtapa(indice) {
  return String(indice + 1).padStart(2, "0");
}

/** Largura da linha até a etapa `indice`, em % do trilho (0 → 0%, 7 → 100%). */
export function preenchimentoDoTrilho(indice) {
  return (indice / (ETAPAS.length - 1)) * 100;
}

export function classeDoNo(indice, etapaAtual) {
  return `node${indice < etapaAtual ? " done" : ""}${indice === etapaAtual ? " on" : ""}`;
}
